import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useDispatch, useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import ChonDiaChi from "../component/ChonDiaChi";
import AnhCCCD from "../component/AnhCCCD";
import Spinner from "../component/Spinner";
import moment from "moment";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { LIST_NATION, RolesRight } from "../configs";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DateTimePicker from "react-datetime-picker";
import SearchBoxModal from "../component/SearchBoxModal";
import { Link } from "react-router-dom";
import { checkRole } from "../model";
import Loading from "../component/Loading";
import { Modal } from "react-bootstrap";
import ItemRoleRight from "../phan-quyen/ItemRoleRight";
import men_teacher from "../assets/img/men-teacher.png"
import girl_teacher from "../assets/img/girl-teacher.png"
import getCroppedImg from "../component/getCroppedImg";
import Cropper from "react-easy-crop";
import Moment from "react-moment";
import ModalHopDongNhanSu from "../hop-dong/ModalHopDongNhanSu";

const _ = require("lodash")

export default function FormUsersPage() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    // Modal xem các hợp đồng áp dụng cho nhân sự đang mở.
    const [showHopDong, setShowHopDong] = useState(false);

    const [dateSelect, setDateSelect] = useState({
        birthday: null, cccd_date: null, birthday_child_1: null, birthday_child_2: null, birthday_child_3: null, birthday_child_4: null, datejoining: null, ngaynghiviec: null, listhopdong: null, checkin_status_date: null,
        datehdtv_start: null, datehdtv_end: null, datehdld_start_1: null, datehdld_end_1: null, datehdld_start_2: null, datehdld_end_2: null, datehdld_start_3: null, datehdld_end_3: null, hd_status: null, ungphep: 0,
        datestart_tapnghe: null, dateend_tapnghe: null, datestart_khoanviec: null, dateend_khoanviec: null
    });

    const allowSetRoles = checkRole(user, 'list-users', 'roles');
    const rolesAllCompany = checkRole(user, 'list-users', 'viewallcompany');
    const checkLeave = checkRole(user, 'list-users', 'leave');
    const [avatar, setAvatar] = useState(null);
    const [savingPhep, setSavingPhep] = useState(false);
    const [currentBalance, setCurrentBalance] = useState(0);
    const [savingUngPhep, setSavingUngPhep] = useState(false);
    const [currentUngPhep, setCurrentUngPhep] = useState(0);
    const [loadingImage, setLoadingImage] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [localRole, setLocalRole] = useState(RolesRight);
    const inputRef = useRef(null);

    const [imageSrc, setImageSrc] = useState(null); // ảnh gốc chọn từ input
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [nameFile, setNameFile] = useState(null);

    const defaultdetail = {
        author_id: user.data.id,
        fullname: '',
        code: '',
        number_code: '',
        oldcode: '',
        sex: '',
        mobile: '',
        email: '',
        birthday: '',
        nation: '',
        address: '',
        status: 3,
        cccd: '',
        company_id: null,
        part_id: null,
        chucvu_id: '',
        datejoining: '',
        role_id: 2,
        typeaccount: 1,
        dateCCCD: '',
        cccd_address: '',
        address_tc: '',
        tinh_id: '',
        phuongxa_id: '',
        address_tc_chitiet: '',
        cccd_front: '',
        cccd_back: '',
        dctc: '',
        bank_id: '',
        bank_address: '',
        bank_city: '',
        bhxh_id: '',
        mst_id: '',
        qualification: '',
        majors: '',
        highschool: '',
        marital_status: '',
        fullname_love: '',
        total_child: '',
        fullname_child_1: '',
        birthday_child_1: '',
        fullname_child_2: '',
        birthday_child_2: '',
        fullname_child_3: '',
        birthday_child_3: '',
        datestart_tapnghe: '',
        dateend_tapnghe: '',
        datestart_khoanviec: '',
        dateend_khoanviec: '',
        time_test: '',
        datehdtv_start: '',
        datehdtv_end: '',
        datehdld_start_1: '',
        datehdld_end_1: '',
        datehdld_start_2: '',
        datehdld_end_2: '',
        datehdld_start_3: '',
        datehdld_end_3: '',
        hd_status: '',
        luong_ct: '',
        ngaynghiviec: '',
        checkin_status: 3,
        checkin_status_date: '',
        usertype: 1,
        ungphep: 0,
        ungphep_year: 0,
        total_phep: 0,
        bank_name: 'Techcombank'
    }
    useEffect(
        function () {
            // console.log(checkLeave);
            if (id > 0) {
                Axios.get(URL_LIST_ALL + "users/" + id, user.config).then(async (res) => {
                    if (res.data.status === "success") {
                        const dataif = res.data.data
                        if (!dataif.leave) {
                            dataif.leave = 0
                        } else {
                            dataif.sophep = dataif.leave
                        }
                        if (!dataif.songaybu) dataif.songaybu = 0
                        setDetail(dataif);
                        setDateSelect({
                            birthday: dataif.birthday, cccd_date: dataif.cccd_date, birthday_child_1: dataif.birthday_child_1, birthday_child_2: dataif.birthday_child_2, birthday_child_3: dataif.birthday_child_3, datejoining: dataif.datejoining, ngaynghiviec: dataif.ngaynghiviec, checkin_status_date: dataif.checkin_status_date,
                            datehdtv_start: dataif.datehdtv_start, datehdtv_end: dataif.datehdtv_end, datehdld_start_1: dataif.datehdld_start_1, datehdld_end_1: dataif.datehdld_end_1, datehdld_start_2: dataif.datehdld_start_2, datehdld_end_2: dataif.datehdld_end_2, datehdld_start_3: dataif.datehdld_start_3, datehdld_end_3: dataif.datehdld_end_3,
                            datestart_tapnghe: dataif.datestart_tapnghe, dateend_tapnghe: dataif.dateend_tapnghe, datestart_khoanviec: dataif.datestart_khoanviec, dateend_khoanviec: dataif.dateend_khoanviec
                        })
                        // Deep clone RolesRight
                        let myrole = dataif.roleright;
                        let newDT = setRoleChecked(_.assign({}, RolesRight), myrole);
                        setAvatar(dataif.avatar)
                        setLocalRole(newDT);
                        setLocalRole(newDT);

                    } else console.log(res.data.message);
                }).catch((err) => console.log(err));
            }
        }, [user, id, autoRefresh]
    );

    const setRoleChecked = (main, role) => {
        let newDT = _.assign({}, RolesRight, main);
        Object.keys(newDT).map((key) => {
            let child1 = Object.assign({}, newDT[key]);
            child1.checked = role[key] ? role[key].checked : false;
            if (child1.children) {
                let children = Object.assign({}, child1.children);
                Object.keys(children).map((key2) => {
                    let child2 = Object.assign({}, children[key2]);
                    if (role[key] && role[key].children && role[key].children[key2]) {
                        child2.checked = role[key].children[key2].checked;
                    }
                    children[key2] = child2;
                    return key2;
                });
                child1.children = children;
            }
            newDT[key] = child1
            return key;
        });
        return newDT
    }

    let validForm = {
        fullname: Yup.string().trim().nullable().required('Nhập họ và tên ').max(150, "Độ dài không quá 150 ký tự"),
        birthday: Yup.string().trim().nullable().required('Nhập ngày sinh'),
        cccd_date: Yup.string().trim().nullable().required('Nhập ngày cấp cccd/cmnd'),
        cccd_address: Yup.string().trim().nullable().required('Nhập nơi cấp cccd/cmnd'),
        sex: Yup.string().trim().nullable().required('Chọn giới tính'),
        // majors: Yup.string().trim().nullable().required('Nhập chuyên ngành'),
        // highschool: Yup.string().trim().nullable().required('Nhập trường đào tạo'),
        master_id: Yup.string().trim().nullable().required('Chọn quản lý trực tiếp'),
        cccd: Yup.string().trim().nullable().required('Vui lòng nhập CCCD để tránh trùng lặp'),
        datejoining: Yup.string().trim().nullable().required('Vui lòng nhập ngày bắt đầu làm việc'),
        role_id: Yup.string().trim().nullable().when("typeaccount", (type) => {
            if (type < 2) return Yup.string().required("Chọn quyền hạn tài khoản")
        })
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];
            setLoading(true)
            if (values.checkin_status == 1 && values.checkin_status_date) {
                values.checkin_status_date = null
            }
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'users/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'users', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const handleDate = (name, value) => {
        formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        newDate[name] = value
        setDateSelect(newDate)
    };

    useEffect(function () {
        if (id > 0 && detail) {
            Axios.get(URL_LIST_ALL + 'ngayphepconlai/' + detail.id, user.config).then(res => {
                if (res.data.status === 'success') {
                    const data = res.data.data;
                    formik.setFieldValue('leave', data.balance);
                    formik.setFieldValue('tongphepnghi', data.tongphepnghi);
                    formik.setFieldValue('ungphep_year', data.ungphep_year);
                    setCurrentBalance(data.balance);
                    setCurrentUngPhep(data.ungphep_year);
                }
            }).catch(err => console.log(err));
        }
    }, [detail, id, autoRefresh]); // eslint-disable-line



    const savePhep = () => {
        const leaveVal = formik.values.leave;
        if (leaveVal === '' || leaveVal === null || leaveVal === undefined) {
            confirmAlert({ title: 'Lỗi', message: 'Vui lòng nhập số ngày phép', buttons: [{ label: 'OK' }] });
            return;
        }
        const newVal = parseFloat(leaveVal);
        const delta = newVal - currentBalance;
        if (delta === 0) {
            confirmAlert({ title: 'Thông báo', message: 'Số ngày phép không thay đổi', buttons: [{ label: 'OK' }] });
            return;
        }
        setSavingPhep(true);
        Axios.post(URL_LIST_ALL + 'ngayphep', {
            user_id: detail.id,
            point: delta,
            note: 'Sửa phép',
            status: 1,
            author_id: user.data.id,
        }, user.config).then(res => {
            setSavingPhep(false);
            if (res.data.status === 'success') {
                confirmAlert({ title: 'Thành công', message: 'Cập nhật số ngày phép thành công', buttons: [{ label: 'OK' }] });
                setAutoRefresh(v => !v);
            } else {
                confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
            }
        }).catch(err => {
            setSavingPhep(false);
            console.log(err);
        });
    };

    const saveUngPhep = () => {
        const ungVal = formik.values.ungphep;
        if (ungVal === '' || ungVal === null || ungVal === undefined) {
            confirmAlert({ title: 'Lỗi', message: 'Vui lòng nhập số phép ứng', buttons: [{ label: 'OK' }] });
            return;
        }
        const newVal = parseFloat(ungVal);
        if (newVal <= 0) {
            confirmAlert({ title: 'Lỗi', message: 'Số phép ứng phải lớn hơn 0', buttons: [{ label: 'OK' }] });
            return;
        }
        setSavingUngPhep(true);
        Axios.post(URL_LIST_ALL + 'ngayphep', {
            user_id: detail.id,
            point: newVal,
            type: 'ADVANCE_GRANT',
            note: 'Ứng phép',
            status: 1,
            author_id: user.data.id,
        }, user.config).then(res => {
            setSavingUngPhep(false);
            if (res.data.status === 'success') {
                confirmAlert({ title: 'Thành công', message: 'Cập nhật số phép ứng thành công', buttons: [{ label: 'OK' }] });
                setAutoRefresh(v => !v);
            } else {
                confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
            }
        }).catch(err => {
            setSavingUngPhep(false);
            console.log(err);
        });
    };

    const saveRole = () => {
        setLoading(true);
        Axios.post(URL_LIST_ALL + 'users_roles', { user_id: detail.id, role_id: detail.role_id, role_list: localRole }, user.config).then(res => {
            setLoading(false);
            if (res.data.status === "success") {
                confirmAlert({
                    title: 'Thành công',
                    message: 'Cập nhật quyền thành công',
                    buttons: [{ label: 'OK' }]
                });
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
                setLoading(false);
            }
        }).catch(err => console.log(err));
    }


    useEffect(() => {
        if (detail && avatar && avatar != detail.avatar) {
            Axios.post(URL_LIST_ALL + 'users_avatar', { user_code: detail.code, user_id: detail.id, url: avatar, status: 1 }, user.config).then(res => {

            }).catch(err => console.log(err));
        }
    }, [avatar, detail && detail.avatar])



    // Hàm này lưu vùng crop tính theo pixel
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // Khi người dùng chọn file từ input
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageDataUrl = await readFile(file);
            setNameFile(file.name);

            setImageSrc(imageDataUrl);
            setShowCropper(true);
        }
    };

    // Hàm đọc file thành base64 để hiển thị cropper
    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.readAsDataURL(file);
        });
    }

    // Hàm crop và upload ảnh
    const onCropConfirm = async () => {
        try {
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
            const resizedBlob = croppedImageBlob; // hoặc resize tiếp nếu muốn

            let data = new FormData();
            data.append("type", "s3");
            data.append("name", "file");
            data.append("file", resizedBlob, nameFile); // đổi tên nếu muốn
            data.append("filetype", resizedBlob.type);

            setLoadingImage(true);
            Axios.post(URL_LIST_ALL + "fileupload", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: user.config.headers.Authorization,
                },
            })
                .then((res) => {
                    if (res.data.status === "success") {
                        const url = res.data.message;
                        if (url) {
                            setAvatar(url);
                            setLoadingImage(false);
                            setShowCropper(false);
                            setImageSrc(null);
                        }
                    } else {
                        setLoadingImage(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingImage(false);
                });
        } catch (e) {
            console.error(e);
        }
    };


    return (
        <AkkhorLayout idrole="list-users">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/list-users">Quản lý nhân viên</Link>
                    </li>
                    <li>{id ? 'Sửa tài khoản' : 'Thêm mới tài khoản'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} tài khoản</h3>
                        </div>
                        {id > 0 &&
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-info"
                                    onClick={() => setShowHopDong(true)}
                                    title="Xem các hợp đồng, văn bản áp dụng cho nhân sự này"
                                >
                                    <span className="fas fa-file-contract"></span> Hợp đồng của nhân sự
                                </button>
                            </div>
                        }
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            {id > 0 && detail &&
                                <div className="col-12 info-table table-responsive">
                                    <h5>Ảnh đại diện:</h5>
                                    <div className="avatar-group mt-3">
                                        <button type="button" className="btn p-0 btn-avatar" onClick={() => inputRef.current.click()}>
                                            {loadingImage ? (
                                                "Đang tải..."
                                            ) : avatar ? (
                                                <img src={avatar} alt="" className="avatar" />
                                            ) : (
                                                <img
                                                    src={(detail.sex == "Nam" ? men_teacher : girl_teacher)}
                                                    alt=""
                                                    className="avatar"
                                                />
                                            )}
                                            <span className="fas fa-upload upload-icon"></span>
                                        </button>
                                        <input
                                            type="file"
                                            id="file"
                                            ref={inputRef}
                                            style={{ display: "none" }}
                                            accept="image/*"
                                            onChange={onFileChange}
                                        />

                                        {showCropper && (
                                            <>
                                                <div className="cropper-modal">
                                                    <Cropper
                                                        image={imageSrc}
                                                        crop={crop}
                                                        zoom={zoom}
                                                        aspect={1}
                                                        onCropChange={setCrop}
                                                        onZoomChange={setZoom}
                                                        onCropComplete={onCropComplete}
                                                    />

                                                </div>

                                            </>
                                        )}
                                    </div>
                                    {showCropper && <div className="w-100 mt-2">
                                        <button type="button" className="btn btn-sm btn-info" onClick={onCropConfirm}>Lưu</button>
                                        <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => {
                                            setShowCropper(false);
                                            setImageSrc(null);
                                        }}
                                        >
                                            Hủy
                                        </button>
                                    </div>}
                                </div>
                            }
                            <div className="col-12"></div>
                            {rolesAllCompany ?
                                <div className="col-xl-3 col-lg-6 col-12 form-group">
                                    <label>Công ty </label>
                                    <SearchBoxModal apiname={"company"} placeholder="Chọn công ty" colvalue={'id'} colname={'title'} defaultValue={formik.values['company_id']} name='company_id'
                                        onChange={async (e) => {
                                            // setCompanyId(e)
                                            await formik.setFieldValue('company_id', e)
                                        }}></SearchBoxModal>
                                    <AlertErrorForm formik={formik} name="company_id"></AlertErrorForm>
                                </div>
                                :
                                <input type="hidden" placeholder="" className="form-control height32" {...formik.getFieldProps("company_id")} />
                            }
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Phòng ban </label>
                                <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} defaultValue={formik.values['part_id']} name='part_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('part_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="part_id"></AlertErrorForm>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chức vụ </label>
                                <SearchBoxModal apiname={"chucvu"} placeholder="Chọn chức vụ" colvalue={'id'} colname={'title'} defaultValue={formik.values['chucvu_id']} name='chucvu_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('chucvu_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="chucvu_id"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Phân loại <span className="text-danger">*</span></label>
                                <select className="form-select height32" {...formik.getFieldProps("typeaccount")}>
                                    <option value="1">Khối HO</option>
                                    <option value="2">Khối Sale</option>
                                    <option value="3">Member Ship</option>
                                </select>
                                <AlertErrorForm formik={formik} name="typeaccount"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Họ và tên <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="fullname"></AlertErrorForm>
                            </div>
                            {id > 0 ?
                                <div className="col-xl-3 col-lg-6 col-12 form-group">
                                    <label>Mã số nhân viên  <span className="text-danger">*</span></label>
                                    <input type="text" placeholder="" className="form-control height32"  {...formik.getFieldProps("code")} autoComplete="off" />
                                    <AlertErrorForm formik={formik} name="code"></AlertErrorForm>
                                </div>
                                : ''
                            }

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Mã nhân viên cũ</label>
                                <input type="text" placeholder="" className="form-control height32"  {...formik.getFieldProps("oldcode")} autoComplete="off" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Giới tính <span className="text-danger">*</span></label>
                                <select className="form-select height32" {...formik.getFieldProps("sex")}>
                                    <option value="" disabled>Hãy chọn giới tính</option>
                                    <option value="Nam">Nam</option>
                                    <option value="Nữ">Nữ</option>
                                    <option value="Khác">Khác</option>
                                </select>
                                <AlertErrorForm formik={formik} name="sex"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày sinh <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('birthday', value) }} value={dateSelect.birthday ? new Date(dateSelect.birthday) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                {(formik && formik.values.birthday) && <Moment format="DD/MM/YYYY">{new Date(formik.values.birthday)}</Moment>}
                                <AlertErrorForm formik={formik} name="birthday"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số CCCD/CMND: <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("cccd")} />
                                <AlertErrorForm formik={formik} name="cccd"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày cấp CCCD/CMND: <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('cccd_date', value) }} value={dateSelect.cccd_date ? new Date(dateSelect.cccd_date) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                {(formik && formik.values.cccd_date) && <Moment format="DD/MM/YYYY">{new Date(formik.values.cccd_date)}</Moment>}
                                <AlertErrorForm formik={formik} name="cccd_date"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Nơi cấp CCCD/CMND: <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("cccd_address")} />
                                <AlertErrorForm formik={formik} name="cccd_address"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <ChonDiaChi formik={formik} />
                            <div className="col-12">
                                <AlertErrorForm formik={formik} name="address_tc"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Địa chỉ liên lạc </label>
                                <input type="text" placeholder="Ghi rõ số nhà, Xã/Phường, Tỉnh/Thành phố" className="form-control height32" {...formik.getFieldProps("address")} />
                            </div>
                            <div className="col-12"></div>
                            <AnhCCCD formik={formik} />
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Điện thoại <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("mobile")} />
                                <AlertErrorForm formik={formik} name="mobile"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Email</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("email")} />
                                <AlertErrorForm formik={formik} name="email"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Dân tộc</label>
                                <select className="form-select height32" {...formik.getFieldProps("nation")}>
                                    <option value="" >Chọn dân tộc</option>
                                    {LIST_NATION.map((nation, index) => <option value={nation} key={index.toString()}>{nation}</option>)}
                                </select>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trình độ chuyên môn: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("qualification")} />
                                <AlertErrorForm formik={formik} name="qualification"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chuyên ngành: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("majors")} />
                                <AlertErrorForm formik={formik} name="majors"></AlertErrorForm>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trường đào tạo: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("highschool")} />
                                <AlertErrorForm formik={formik} name="highschool"></AlertErrorForm>
                            </div>

                            <div className="col-12 mt-3" ></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Tình trạng hôn nhân</label>
                                <select className="form-select height32" {...formik.getFieldProps("marital_status")}>
                                    <option value="Chưa kết hôn" >Chưa kết hôn</option>
                                    <option value="Đã kết hôn" >Đã kết hôn</option>
                                    <option value="Đã ly hôn" >Đã ly hôn</option>
                                </select>
                            </div>
                            {((formik.values.marital_status && formik.values.marital_status === "Đã kết hôn") || (formik.values.marital_status && formik.values.marital_status === "Đã ly hôn")) &&
                                <>
                                    {formik.values.marital_status === "Đã kết hôn" &&
                                        <>
                                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                                <label>Họ Tên vợ/chồng: </label>
                                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_love")} />
                                            </div>
                                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                                <label>Số điện thoại vợ/chồng: </label>
                                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("phone_love")} />
                                            </div>
                                        </>
                                    }

                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Số con cái: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("total_child")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 1: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_1")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 1: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_1', value) }} value={dateSelect.birthday_child_1 ? new Date(dateSelect.birthday_child_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        {(formik && formik.values.birthday_child_1) && <Moment format="DD/MM/YYYY">{new Date(formik.values.birthday_child_1)}</Moment>}
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 2: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_2")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 2: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_2', value) }} value={dateSelect.birthday_child_2 ? new Date(dateSelect.birthday_child_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        {(formik && formik.values.birthday_child_2) && <Moment format="DD/MM/YYYY">{new Date(formik.values.birthday_child_2)}</Moment>}
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 3: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_3")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 3: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_3', value) }} value={dateSelect.birthday_child_3 ? new Date(dateSelect.birthday_child_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        {(formik && formik.values.birthday_child_3) && <Moment format="DD/MM/YYYY">{new Date(formik.values.birthday_child_3)}</Moment>}
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 4: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_4")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 4: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_4', value) }} value={dateSelect.birthday_child_4 ? new Date(dateSelect.birthday_child_4) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        {(formik && formik.values.birthday_child_4) && <Moment format="DD/MM/YYYY">{new Date(formik.values.birthday_child_4)}</Moment>}
                                    </div>
                                </>
                            }

                            <div className="col-12 mt-3" ></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Người duyệt đơn <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['master_id']} name='master_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('master_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="master_id"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Người quản lý trực tiếp <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['quanly_id']} name='quanly_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('quanly_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="quanly_id"></AlertErrorForm>
                            </div>
                            {checkLeave ?
                                <>
                                    <div className="col-12"></div>
                                    <div className="col-sm-3 col-12 form-group">
                                        <label>Số ngày phép còn lại</label>
                                        <div className="d-flex gap-2">
                                            <input type="number" placeholder="" className="form-control height32" {...formik.getFieldProps("leave")} />
                                            <button type="button" className="btn btn-sm btn-success text-nowrap" onClick={savePhep} disabled={savingPhep}>
                                                {savingPhep ? <Spinner /> : 'Lưu'}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 col-12 form-group">
                                        <label>Số phép ứng thêm</label>
                                        <div className="d-flex gap-2">
                                            <input type="number" placeholder="vd: 1" className="form-control height32" {...formik.getFieldProps("ungphep")} />
                                            <button type="button" className="btn btn-sm btn-warning text-nowrap" onClick={saveUngPhep} disabled={savingUngPhep}>
                                                {savingUngPhep ? <Spinner /> : 'Lưu'}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 col-12 form-group">
                                        <label>Tổng phép đã ứng trong năm</label>
                                        <input type="number" placeholder="" disabled className="form-control height32" {...formik.getFieldProps("ungphep_year")} />
                                    </div>
                                    <div className="col-sm-3 col-12 form-group">
                                        <label>Số phép đã dùng trong năm</label>
                                        <input type="number" placeholder="" disabled className="form-control height32" {...formik.getFieldProps("tongphepnghi")} />
                                    </div>
                                    <div className="col-12"></div>
                                </>
                                : null}

                            {allowSetRoles &&
                                <>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Quyền <span className="text-danger">*</span></label>
                                        <SearchBoxModal apiname={"roles"} alldata={"?limit=25"} placeholder="Chọn quyền" colvalue={'id'} colname={'title'} defaultValue={formik.values['role_id']} name='role_id'
                                            onChange={async (e) => {
                                                await formik.setFieldValue('role_id', e)
                                            }}></SearchBoxModal>
                                        <AlertErrorForm formik={formik} name="role_id"></AlertErrorForm>

                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Xem chi tiết</label>
                                        <button type="button" onClick={() => setShowModal(true)} className="btn btn-sm btn-info text-white">Xem quyền</button>
                                    </div>
                                </>
                            }


                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chấm công</label>
                                <select className="form-select height32" {...formik.getFieldProps("checkin_status")}>
                                    <option value="1">Phải chấm công</option>
                                    <option value="2">Miễn chấm công</option>
                                    <option value="3">Không trong danh sách chấm công</option>
                                </select>
                            </div>

                            {formik.values.checkin_status == 2 &&
                                <div className="col-12 col-sm-6 col-lg-3 form-group">
                                    <label>Ngày bắt đầu Miễn chấm công</label>
                                    <DateTimePicker onChange={(value) => { handleDate('checkin_status_date', value) }} value={dateSelect.checkin_status_date ? new Date(dateSelect.checkin_status_date) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                    {(formik && formik.values.checkin_status_date) && <Moment format="DD/MM/YYYY">{new Date(formik.values.checkin_status_date)}</Moment>}
                                </div>
                            }
                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chọn ngân hàng</label>
                                <select className="form-select height32" {...formik.getFieldProps("bank_name")}>
                                    <option value="Techcombank">Techcombank</option>
                                    <option value="BIDV">BIDV</option>
                                    <option value="MBBank">MBBank</option>
                                </select>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số TK ngân hàng:	</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bank_id")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chi nhánh:	</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bank_address")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Tỉnh/Thành phố:	</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bank_city")} />
                            </div>
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số sổ BHXH: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bhxh_id")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Mã số thuế: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("mst_id")} />
                            </div>
                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày gia nhập <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('datejoining', value) }} value={dateSelect.datejoining ? new Date(dateSelect.datejoining) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                {(formik && formik.values.datejoining) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datejoining)}</Moment>}

                                <AlertErrorForm formik={formik} name="datejoining"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trạng thái làm việc: </label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="6">Khoán việc</option>
                                    <option value="5">Cộng tác viên</option>
                                    <option value="4">Thực tập sinh</option>
                                    <option value="3">Chưa nhận việc</option>
                                    <option value="2">Đang thử việc</option>
                                    <option value="1">Đang chính thức</option>
                                    <option value="0">Đã nghỉ</option>
                                </select>
                            </div>
                            {(formik.values.status === 0 || formik.values.status === "0") &&
                                <div className="col-xl-3 col-lg-6 col-12 form-group">
                                    <label>Ngày nghỉ việc: </label>
                                    <DateTimePicker onChange={(value) => { handleDate('ngaynghiviec', value) }} value={dateSelect.ngaynghiviec ? new Date(dateSelect.ngaynghiviec) : ''} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                    {(formik && formik.values.ngaynghiviec) && <Moment format="DD/MM/YYYY">{new Date(formik.values.ngaynghiviec)}</Moment>}

                                </div>
                            }
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐ tập nghề: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datestart_tapnghe', value) }} value={dateSelect.datestart_tapnghe ? new Date(dateSelect.datestart_tapnghe) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datestart_tapnghe) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datestart_tapnghe)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐ tập nghề: </label>
                                <DateTimePicker onChange={(value) => { handleDate('dateend_tapnghe', value) }} value={dateSelect.dateend_tapnghe ? new Date(dateSelect.dateend_tapnghe) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.dateend_tapnghe) && <Moment format="DD/MM/YYYY">{new Date(formik.values.dateend_tapnghe)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐ khoán việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datestart_khoanviec', value) }} value={dateSelect.datestart_khoanviec ? new Date(dateSelect.datestart_khoanviec) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datestart_khoanviec) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datestart_khoanviec)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐ khoán việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('dateend_khoanviec', value) }} value={dateSelect.dateend_khoanviec ? new Date(dateSelect.dateend_khoanviec) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.dateend_khoanviec) && <Moment format="DD/MM/YYYY">{new Date(formik.values.dateend_khoanviec)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Thời gian thử việc (tháng): </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("time_test")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐ thử việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdtv_start', value) }} value={dateSelect.datehdtv_start ? new Date(dateSelect.datehdtv_start) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdtv_start) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdtv_start)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐ thử việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdtv_end', value) }} value={dateSelect.datehdtv_end ? new Date(dateSelect.datehdtv_end) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdtv_end) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdtv_end)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Lương thử việc (%): </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("time_test")} />
                            </div>
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 1: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_1', value) }} value={dateSelect.datehdld_start_1 ? new Date(dateSelect.datehdld_start_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_start_1) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_start_1)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 1: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_1', value) }} value={dateSelect.datehdld_end_1 ? new Date(dateSelect.datehdld_end_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_end_1) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_end_1)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 2: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_2', value) }} value={dateSelect.datehdld_start_2 ? new Date(dateSelect.datehdld_start_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_start_2) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_start_2)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 2: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_2', value) }} value={dateSelect.datehdld_end_2 ? new Date(dateSelect.datehdld_end_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_end_2) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_end_2)}</Moment>}
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 3: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_3', value) }} value={dateSelect.datehdld_start_3 ? new Date(dateSelect.datehdld_start_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_start_3) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_start_3)}</Moment>}

                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 3: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_3', value) }} value={dateSelect.datehdld_end_3 ? new Date(dateSelect.datehdld_end_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                                {(formik && formik.values.datehdld_end_3) && <Moment format="DD/MM/YYYY">{new Date(formik.values.datehdld_end_3)}</Moment>}

                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Tình trạng hợp đồng: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("hd_status")} />
                            </div>

                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Lương: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("luong_ct")} />
                            </div>

                            <div className="col-12 mt-3" ><hr /></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu tài khoản</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loading && (<Loading />)}
            <Modal show={showModal} onHide={() => setShowModal(false)} animation={true} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Phân quyền</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {Object.keys(localRole).map((key, i) =>
                            <div className="col-12 col-sm-6 mb-3" key={i}>
                                <div className="border p-3 shadow-sm h-100">
                                    <ItemRoleRight key={i} RolesRight={localRole[key]} name={key} parent={key} marginleft={1} dt={localRole} onChange={setLocalRole} />
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Hủy</button>
                    <button className="btn btn-primary" type="button" onClick={() => { saveRole() }} disabled={loading}>
                        {loading ? <span className="spinner-border spinner-border-sm me-2" /> : null}
                        Cập nhật
                    </button>
                </Modal.Footer>
            </Modal>

            <ModalHopDongNhanSu
                show={showHopDong}
                onHide={() => setShowHopDong(false)}
                userId={id}
                userName={detail ? detail.fullname : ""}
            />

        </AkkhorLayout>
    );
}
